module.exports = __webpack_public_path__ + "static/img/图层111.fcb9ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/图层111.png
// module id = n60q
// module chunks = 1